import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Theme } from 'studio-components';
import { NotificationSize, NotificationType } from '../../types/notification.types';

@Component({
  selector: 'studio-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent {
  @Input() type: NotificationType = NotificationType.Info;
  @Input() size: NotificationSize = 'medium';
  @Input() theme: Theme = 'light';
  @Input() description: string;
  @Input() transparent = false;
  @Output() confirm = new EventEmitter();
  @Output() cancel = new EventEmitter();
}
